export const USER_LOGOUT = 'RA/USER_LOGOUT';
export const userLogoutAction = redirectTo => ({
  type: USER_LOGOUT,
  payload: { redirectTo },
  meta: { auth: true },
});
